export const REQUEST_STATUS = [
  {
    value: 'BUSINESS_REQUEST_CONFIRMATION_NEW',
    label: 'درخواست داده‌شده',
    disableDelete: false,
  },
  {
    value: 'BUSINESS_REQUEST_CONFIRMATION_CONFIRMED',
    label: 'تایید شده',
    disableDelete: true,
  },
  {
    value: 'BUSINESS_REQUEST_CONFIRMATION_REJECTED',
    label: 'عدم تایید',
    disableDelete: true,
  },
  {
    value: 'BUSINESS_REQUEST_CONFIRMATION_CANCELED',
    label: 'انصراف توسط کسب‌وکار',
    disableDelete: true,
  },
];
